import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from 'react-bootstrap';
import EditableAvatar from '../../../components/EditableAvatar';
import GenericCards from '../../../components/GenericCards';
import ModalHeader from '../../../components/ModalHeader';
import { getAllProfiles } from '../../../services/profiles';
import { ssnNumberMask } from '../../../utils/utils';

export type customSummaryModalProps = {
  show: boolean;
  handleClose: () => void;
};

const SummaryModal = ({ show, handleClose }: customSummaryModalProps) => {
  const profile = getAllProfiles().data.filter((x) => x.id === '5');

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="custom-summary-modal-size"
      style={{ maxWidth: '765', maxHeight: '788' }}
    >
      <ModalHeader closeButton>
        <h4 className="text-truncate">Summary</h4>
      </ModalHeader>
      <ModalBody>
        <section>
          <EditableAvatar name={profile[0].name} variant={'static'}>
            {
              <>
                <h4 className={'text-sm-24-lg-32  fw-bold'}>Andy Smith</h4>
                <span className={'fw-light'} style={{ color: '#2F55DD' }}>
                  (Family member eligibility requirement)
                </span>
              </>
            }
          </EditableAvatar>
        </section>
        <section className="mt-12">
          <div
            className={'border-light-gray rounded-1'}
            style={{ maxWidth: '688px' }}
          >
            <GenericCards variant={'transperant'} className={'p-0'}>
              <div className={'card-item p-10'}>
                <div className={'d-flex justify-content-between'}>
                  <h3 className={'h6'}>{'Relationship'}</h3>
                </div>
                <Row className={'mt-3'}>
                  <Col className={'col-6 col-lg-3'}>
                    <div className={'text-caption text-ligther-grey fw-light'}>
                      {'Relationship Status'}
                    </div>
                    <div className={'mt-1 text-fs-base fw-normal'}>
                      {'Biological Child'}
                    </div>
                  </Col>
                  <Col className={'col-6 col-lg-3'}>
                    <div className={'text-caption text-ligther-grey fw-light'}>
                      {'Dependent Disabled'}
                    </div>
                    <div className={'mt-1 text-fs-base fw-normal'}>{'No'}</div>
                  </Col>
                  <Col className={'col-12 col-lg-3 mt-10 mt-lg-0'}>
                    <div className={'text-caption text-ligther-grey fw-light'}>
                      {'Full-time Student'}
                    </div>
                    <div className={'mt-1 text-fs-base fw-normal'}>{'No'}</div>
                  </Col>
                </Row>
              </div>
              <div className={'card-item p-10 border-top border-info'}>
                <div className={'d-flex justify-content-between'}>
                  <h3 className={'h6'}>{'Documentation'}</h3>
                </div>
                <Row className={'mt-3'}>
                  <Col className={'col-6 col-lg-3'}>
                    <div className={'text-caption text-ligther-grey fw-light'}>
                      {'Birth Certificate'}
                    </div>
                    <div className={'mt-1 text-fs-base fw-normal'}>
                      {'File Upload'}
                    </div>
                  </Col>
                  <Col className={'col-6 col-lg-3 align-self-end'}>
                    <div className={'text-caption text-info fw-light'}>
                      {'filename.pdf'}
                      <FontAwesomeIcon
                        icon={light('paperclip')}
                        className={'ms-3'}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <div className={'card-item p-10 border-top border-info'}>
                <div className={'d-flex justify-content-between'}>
                  <h3 className={'h6'}>{'Social Security Number'}</h3>
                </div>
                <Row className={'mt-3'}>
                  <Col className={'col-6 col-lg-3'}>
                    <div className={'text-caption text-ligther-grey fw-light'}>
                      {'SSN'}
                    </div>
                    <div className={'mt-1 text-fs-base fw-normal'}>
                      {ssnNumberMask('123456789')}
                    </div>
                  </Col>
                </Row>
              </div>
            </GenericCards>
          </div>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SummaryModal;
